<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-white12" v-if="$route.path != '/'">

      <div class="container-fluid">
        <div class="row header-width">
            <div class="col-lg-3 col-md-3">
              <router-link to="/" class="navbar-brand logosec"><img src="./assets/images/shopmonks.png" alt="" class="img-fluid" ></router-link>
            </div>
            <div class="col-lg-9 col-md-9">
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="row header-width">

            <div class="col-lg-12">
              <ul class="navbar-nav mr-auto txt-r pad-10">
                <li class="nav-item">
                  <router-link class="nav-link" to="/dashboard"> Dashboard</router-link>
                </li>
                <li class="nav-item ">
                  <router-link class="nav-link" to="/members">Vendors </router-link>
                </li>
                <li class="nav-item ">
                    <router-link class="nav-link" to="/profile">Profile</router-link>


                </li>
                <li class="nav-item">

                    <router-link  to="to"  @click.native="logout" class="nav-link">Logout</router-link>

                </li>
            </ul>

            </div>

            </div>
            </div>
                </div>

              </div>
            </div>
                </nav>
    <router-view/>
    <div class="container-fluid bg-gray footer" v-if="$route.path != '/'">
        <div class="col-lg-10 offset-lg-1">
            <div class="row">
              <div class="col-lg-12 ">
                <p class="mb-0"> All Rights Reserved.
                    &copy Copyright 2020 RMC</p>
            </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
    
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions([
      'clearAll'
    ]),
    logout () {
      this.userInfo = ''
      this.token = ''
      this.clearAll()
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue